import React, { useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import ModalComponent from "../../../Appoinment/component/ModalComponent";
import { useLocation } from "react-router-dom";
import { BUCKET_URL } from "../../../../../Service/api/ApiUrls";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import AddReports from "../AddForms/AddReports";

// PDF worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

// Helpers
const buildFileUrl = (filepath = "", fileName = "") => {
  if (!fileName) return null;
  const cleanPath = filepath ? filepath.replace(/^\/+|\/+$/g, "") + "/" : "";
  return `${BUCKET_URL}/${cleanPath}${fileName}`;
};
const isImageFile = (filename = "") =>
  /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filename);
const isPdfFile = (filename = "") => /\.pdf$/i.test(filename);

const Reports = ({ ReportsData, refetch }) => {
  const [reportsModal, setReportsModal] = useState(false);
  const location = useLocation();
  const { consultantId } = location.state || {};

  const todayReports = ReportsData?.data?.today || [];
  const thisWeekReports = ReportsData?.data?.thisWeek || [];

  const handleAdd = () => setReportsModal(true);

  const renderThumbnail = (report, index) => {
    const fileUrl = buildFileUrl(report.filepath, report.fileName);

    return (
      <Col key={index} xs="auto" className="text-center">
        {fileUrl ? (
          <a
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <div
              style={{
                height: "130px",
                width: "100px",
                overflow: "hidden",
                border: "1px solid #ddd",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "6px",
              }}
            >
              {isImageFile(report.fileName) ? (
                <img
                  src={fileUrl}
                  alt={report.fileName}
                  style={{ maxHeight: "100%", maxWidth: "100%" }}
                />
              ) : isPdfFile(report.fileName) ? (
                <Document file={fileUrl}>
                  <Page pageNumber={1} width={100} />
                </Document>
              ) : (
                <span className="text-muted f-12">Unsupported</span>
              )}
            </div>
          </a>
        ) : null}
        <div style={{ fontSize: "12px", color: "#555" }}>
          {report.reportTitle || "Report"}
        </div>
      </Col>
    );
  };

  return (
    <div>
      {/* Add Report Button */}
      {consultantId && (
        <div className="d-flex justify-content-end mb-3">
          <button
            className="btn btn-violet d-flex align-items-center"
            onClick={handleAdd}
          >
            <span className="material-symbols-outlined me-2">add</span>
            Add Report
          </button>
        </div>
      )}

      {/* Today's Reports */}
      {todayReports.length > 0 && (
        <Card className="shadow-sm mb-3">
          <Card.Body>
            <div className="mb-2 fw-bold">Today</div>
            <Row className="g-3">
              {todayReports.map((report, index) => renderThumbnail(report, index))}
            </Row>
          </Card.Body>
        </Card>
      )}

      {/* This Week's Reports */}
      {thisWeekReports.length > 0 && (
        <Card className="shadow-sm mb-3">
          <Card.Body>
            <div className="mb-2 fw-bold">This Week</div>
            <Row className="g-3">
              {thisWeekReports.map((report, index) => renderThumbnail(report, index))}
            </Row>
          </Card.Body>
        </Card>
      )}

      {/* No Reports Fallback */}
      {todayReports.length === 0 && thisWeekReports.length === 0 && (
        <div className="text-center">No reports available for today or this week.</div>
      )}

      {/* Add Reports Modal */}
      <ModalComponent
        title="Add Report"
        show={reportsModal}
        body={
          <AddReports
            setReportsModal={setReportsModal}
            onSuccess={() => {
              setReportsModal(false);
              refetch && refetch();
            }}
          />
        }
        onClose={() => setReportsModal(false)}
      />
    </div>
  );
};

export default Reports;
